export default {
  path: '/record/:pid(\\d+)/:id(\\d+)',
  name: 'record',
  component: () => import('../views/record'),
  hidden: true,
  meta: {
    title: 'gamePlay 录制',
    keys: ['vrec'],
  },
}
